import {useQuery} from '@tanstack/react-query';
import type {AuthSession} from '../auth';
import type {InterfaceModel,InterfaceRoute} from '../model';
import {financialOperatingWorkspaceQuery} from '../query';
import {RendererStateView} from '../components/renderer-state';
import {FinancialWorkspace} from '../views/financial-workspace';

export function TenantSurface({model,route,session,onSignOut}:{model:InterfaceModel;route:InterfaceRoute;session:AuthSession;onSignOut:()=>void}){
  const bootstrap=session.bootstrap!,claims=session.claims!,token=session.token!;
  const tenantId=String(claims[bootstrap.tenantClaim]);
  const principal=String(claims[bootstrap.principalClaim]);
  const query=useQuery(financialOperatingWorkspaceQuery(model,token,tenantId));
  if(query.isPending)return <RendererStateView state="loading" title={route.title} detail="Loading the evidence-backed financial position…"/>;
  if(query.isError)return <RendererStateView state="refused" title={route.title} detail={query.error.message}/>;
  return <FinancialWorkspace model={model} route={route} workspace={query.data} principal={principal} onSignOut={onSignOut}/>;
}
